import {
  IconChartBar,
  IconSettings,
  IconUserCheck,
  IconShieldCheck,
} from "@tabler/icons-react";

// Tabs shown in the Welcome Survey section's top sub navigation.
// Kept here so the report page and the settings page stay in sync.
// This tab is the only way into settings: the summary card's "Welcome Call
// Setup" button was replaced by the reporting-window picker, so the name moved
// here with the gear it carried.
export const WELCOME_SURVEY_TABS = [
  {
    id: "report",
    label: "Report",
    icon: IconChartBar,
    path: "/welcome-survey",
  },
  {
    id: "rep-quality",
    label: "Rep Quality",
    icon: IconUserCheck,
    path: "/welcome-survey/rep-quality",
  },
  {
    id: "account-quality",
    label: "Account Quality",
    icon: IconShieldCheck,
    path: "/welcome-survey/account-quality",
  },
  {
    id: "setup",
    label: "Welcome Call Setup",
    icon: IconSettings,
    path: "/welcome-survey/settings",
  },
];
